define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "dojo/i18n!nls/mldoStringResource",
    "mw-filename-utils/FileNameUtil",
    "mw-isappfile/Isappfile"
], function (declare, Action, MLDOStrings, FileNameUtil, Isappfile) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        var context = args.context;
        var makeActionAvailable = args.showAction || false;
        this.name =  "runAction";
        this.enabled = makeActionAvailable;
        this.getInvitationDetailsMethod = args.getInvitationDetailsMethod;
        this.label = MLDOStrings.contextMenuRunLabel;
        this.section = {
          id: "MISC",
          name: "MISC",
          allowSubMenu: false,
          forceSubMenu: false
        };
        this.isApplicableTo = function () {
            let fileInfo;
            let selectedFileCount = context.getSelectedRowCount();
            if (!context.isRunEnabled()) {
                return false;
            }
            if (selectedFileCount !== 1) {
                this.enabled = false;
            } else {
                fileInfo = context.getSelectedItemFileInfos()[0];
                if (!fileInfo.isDirectory && context.RUN_SUPPORTED_TYPES.includes(FileNameUtil.getFileNameExtension(fileInfo.name).toLowerCase())) {
                    this.enabled = true;
                } else if (!fileInfo.isDirectory && FileNameUtil.getFileNameExtension(fileInfo.name).toLowerCase() === 'm' && context.getIsRunnableFile()) {
                    this.enabled = true;
                } else {
                    this.enabled = false;
                }

            }
            return this.enabled;
        };
        this.callback = function () {
          if (this.isApplicableTo()) {
            let selectedFile = context.getSelectedItemFileInfos()[0];
            if (context.mockOpenwith()) {
              context.displayMockOpenWithAlert(selectedFile);
              return;
            }
            let invitationDetails;
            if (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function" && this.getInvitationDetailsMethod()) {
                invitationDetails = this.getInvitationDetailsMethod();
            }
            context.handleRunAction(selectedFile.path, selectedFile, invitationDetails.authenticated, invitationDetails.invitationId,
                invitationDetails.invitationName, invitationDetails.invitationTombstoneId);
          }
        };
    }
  });

});
